var ActionMenuDirection = {
  Left: "left",
  Right: "right"
};

export { ActionMenuDirection };
